<ol class="stepper">
    @for (step of steps(); track step.number) {
        <li class="step" [class]="'step--' + step.state" [attr.aria-current]="step.state === 'current' ? 'step' : null">
            @if (step.state === "done" && step.link) {
                <a [routerLink]="step.link">
                    <span class="step-num">{{ step.number }}</span>
                    <span class="step-label">{{ step.label | translate }}</span>
                </a>
            } @else {
                <span>
                    <span class="step-num">{{ step.number }}</span>
                    <span class="step-label">{{ step.label | translate }}</span>
                </span>
            }
        </li>
    }
</ol>
